import { Auth } from "aws-amplify";
import { Component, FormEvent, FunctionComponent } from "react";
import { Form, Alert, Card, Col, Row } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { RouteComponentProps } from "react-router-dom";
import { IPutCourierName } from "../../../client/core";
import { Color, Path, Storage } from "../../../env";
import { Button, variant } from "../../form/Button";

export interface CourierNameState {
    name: string;
    error: string;
}

export interface CourierNameProps extends RouteComponentProps {
    coreAPI: IPutCourierName;
    auth: typeof Auth;
}

export default class CourierName extends Component<CourierNameProps, CourierNameState> {
    constructor(props: CourierNameProps) {
        super(props);
        this.state = {
            name: "",
            error: "",
        };
    }

    handleChange = (name: string) => {
        this.setState({
            name: name,
        });
    };

    handleSubmit = () => {
        const CourierID = localStorage.getItem(Storage.CourierID);
        if (CourierID == null) {
            return this.setState({
                error:
                    "Courier could not be found - please navigate back to the Courier dashboard to resync",
            });
        }
        if (this.state.name.trim() === "") {
            return this.setState({
                error:
                    "Please enter the name of your Courier you wish to trade under",
            });
        }
        this.props.auth.currentSession().then((session) => {
            const token = session.getIdToken().getJwtToken();
            this.props.coreAPI
                .PutCourierName({
                    identityToken: token,
                    courierName: this.state.name,
                    courierID: CourierID!,
                })
                .then((output) => {
                    if (output.statusCode === 403) {
                        localStorage.removeItem(Storage.CourierID);
                        return this.setState({
                            error:
                                "You were forbidden to change the Courier name - please navigate back to the Courier dashboard.",
                        });
                    }
                    return this.props.history.push(Path.RegisterCourierContact);
                })
                .catch((err) =>
                    this.setState({
                        error: err.message,
                    })
                );
        });
    };

    render() {
        const props: CourierNameFormProps = {
            name: this.state.name,
            error: this.state.error,
            onChange: this.handleChange,
            onSubmit: this.handleSubmit,
        };
        return <CourierNameRegistrationForm {...props} />;
    }
}

export interface CourierNameFormProps {
    name: string;
    error: string;
    onChange: (name: string) => void;
    onSubmit: () => void;
}

export const CourierNameRegistrationForm: FunctionComponent<CourierNameFormProps> = (props) => (
    <Form>
        <Alert variant={"danger"} show={props.error !== ""}>
            {props.error}
        </Alert>
        <Row>
            <Col sm={7}>
                <Card>
                    <Card.Body>
                        <Form.Group style={{ "width": "100%" }}>
                            <h4 style={{ textAlign: "center" }}>Registration Form</h4>
                            <Row style={{ marginTop: "1rem" }}>
                                <Col>
                                    <Form.Label>Courier Name</Form.Label>
                                </Col>
                                <Col style={{ marginBottom: "1rem" }} xs={12}>
                                    <Form.Control
                                        type="text"
                                        name={"name"}
                                        id={"name"}
                                        onChange={(e) => props.onChange(e.target.value)}
                                        placeholder="Enter Courier name"
                                    />
                                </Col>
                                <Col style={{ marginBottom: "1rem" }} xs={12}>
                                    <Button
                                        variant={variant.Primary}
                                        name={"Next"}
                                        onClick={() => props.onSubmit()}
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Card.Body>
                </Card >
            </Col>
            <Col sm={5}>
                <Card>
                    <Card.Body>
                        <Card.Title><InfoCircle size={18} /> Info about Courier name</Card.Title>
                        <Card.Text>
                            <p>The Courier Name will be how the customers identify your Courier on the platform.</p>
                        </Card.Text>
                    </Card.Body>
                </Card >
            </Col>
        </Row>
    </Form >
);
